import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'

// Get Sections
export const ListSection = createAsyncThunk('Section-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/section/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Section
export const createSection = createAsyncThunk('Section-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/section/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get section id
export const editSection = createAsyncThunk('Section-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/section/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete section
export const deleteSection = createAsyncThunk('Section-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/section/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListClass = createAsyncThunk('class-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/class/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Section
export const createClass = createAsyncThunk('class-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/class/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get section id
export const editClass = createAsyncThunk('class-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/class/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete section
export const deleteClass = createAsyncThunk('class-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/class/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get AcademicYears
export const ListAcademicYear = createAsyncThunk(
  'AcademicYear-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/academic-year/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create AcademicYear
export const createAcademicYear = createAsyncThunk(
  'AcademicYear-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/academic-year/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get AcademicYear id
export const editAcademicYear = createAsyncThunk(
  'AcademicYear-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/academic-year/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete AcademicYear
export const deleteAcademicYear = createAsyncThunk(
  'AcademicYear-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/academic-year/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get ProgramYears
export const ListProgramYear = createAsyncThunk(
  'ProgramYear-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/program-year/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create ProgramYear
export const createProgramYear = createAsyncThunk(
  'ProgramYear-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/program-year/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get ProgramYear id
export const editProgramYear = createAsyncThunk(
  'ProgramYear-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/program-year/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete ProgramYear
export const deleteProgramYear = createAsyncThunk(
  'ProgramYear-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/program-year/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get ProgramLevels
export const ListProgramLevel = createAsyncThunk(
  'ProgramLevel-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/program-level/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create ProgramLevel
export const createProgramLevel = createAsyncThunk(
  'ProgramLevel-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/program-level/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get ProgramLevel id
export const editProgramLevel = createAsyncThunk(
  'ProgramLevel-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/program-level/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete ProgramLevel
export const deleteProgramLevel = createAsyncThunk(
  'ProgramLevel-delete',
  async (id: string, thunkAPI) => {
    try {
      await axios.get(`/api/program-level/destroy/${id}`)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get Semesters
export const ListSemester = createAsyncThunk('Semester-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/semester/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Semester
export const createSemester = createAsyncThunk('Semester-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/semester/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Semester id
export const editSemester = createAsyncThunk('Semester-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/semester/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Semester
export const deleteSemester = createAsyncThunk('Semester-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/semester/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Countries
export const ListCountry = createAsyncThunk('Country-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/country/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create Country
export const createCountry = createAsyncThunk('Country-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/country/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Country id
export const editCountry = createAsyncThunk('Country-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/country/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Country
export const deleteCountry = createAsyncThunk('Country-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/country/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get VideoCategories
export const ListVideoCategory = createAsyncThunk(
  'VideoCategory-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get('/api/video-category/list', params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create VideoCategory
export const createVideoCategory = createAsyncThunk(
  'VideoCategory-create',
  async (data: {}, thunkAPI) => {
    try {
      const res = await axios.post('/api/video-category/store', data)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get VideoCategory id
export const editVideoCategory = createAsyncThunk(
  'VideoCategory-edit',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`/api/video-category/edit/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete VideoCategory
export const deleteVideoCategory = createAsyncThunk(
  'VideoCategory-delete',
  async (id: string, thunkAPI) => {
    try {
      const res = await axios.get(`/api/video-category/destroy/${id}`)
      return res.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get programs
export const ListProgram = createAsyncThunk('program-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/program/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create program
export const createProgram = createAsyncThunk('program-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/program/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get program id
export const editProgram = createAsyncThunk('program-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/program/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete program
export const deleteProgram = createAsyncThunk('program-delete', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/program/destroy/${id}`)
    return response.data
  } catch (error: any) {
    const message =
      error.response?.data?.errors ??
      error.response?.data?.error ??
      error.response?.data?.message ??
      'Failed to delete program.'

    return thunkAPI.rejectWithValue(message)
  }
})

export const ListTimeSlot = createAsyncThunk('ts-list', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get('/api/slot/list', params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createTimeSlot = createAsyncThunk('ts-create', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/slot/store', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editTimeSlot = createAsyncThunk('ts-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/slot/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteTimeSlot = createAsyncThunk('ts-delete', async (id: string, thunkAPI) => {
  try {
    const res = await axios.get(`/api/slot/destroy/${id}`)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type ToolState = {
  record: any
  records: any
  errors: any
}

const initialState: ToolState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const toolSlice = createSlice({
  name: 'tools',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ListSection.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createSection.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListAcademicYear.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createAcademicYear.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListProgramYear.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createProgramYear.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListProgramLevel.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createProgramLevel.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListSemester.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createSemester.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListCountry.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createCountry.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListVideoCategory.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createVideoCategory.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
      .addCase(ListProgram.fulfilled, (state, action: PayloadAction<any>) => {
        state.records = action.payload
      })
      .addCase(createProgram.rejected, (state, action: PayloadAction<any>) => {
        state.errors = action.payload
      })
  },
})

export const {reset} = toolSlice.actions
export default toolSlice.reducer
